var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 549,
    height: 332,
    viewBox: "0 0 549 332",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.896 209.089V120.861H142.207C148.154 120.861 153.203 121.76 157.353 123.557C161.503 125.354 164.852 127.707 167.401 130.615C169.95 133.523 171.813 136.677 172.989 140.076C174.165 143.474 174.753 146.839 174.753 150.172C174.753 153.375 174.181 156.691 173.038 160.122C171.894 163.553 170.048 166.723 167.499 169.631C164.95 172.539 161.601 174.893 157.451 176.689C153.301 178.487 148.22 179.386 142.207 179.386H132.012V209.089H117.896ZM132.012 166.739H141.423C146.128 166.739 149.87 165.906 152.647 164.239C155.425 162.573 157.402 160.482 158.579 157.966C159.755 155.45 160.343 152.852 160.343 150.172C160.343 147.558 159.771 144.977 158.628 142.428C157.484 139.879 155.539 137.755 152.794 136.056C150.05 134.357 146.259 133.508 141.423 133.508H132.012V166.739Z",
    fill: "url(#paint0_linear_1792_12297)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.224 209.088L209.358 117.822H209.554L247.688 209.088H232.885L224.455 188.109H193.967L185.439 209.088H171.224ZM198.771 176.444H219.651L214.26 163.21C213.279 160.857 212.38 158.586 211.563 156.397C210.746 154.208 209.946 151.61 209.162 148.604C208.377 151.544 207.594 154.126 206.809 156.348C206.025 158.57 205.143 160.857 204.163 163.21L198.771 176.444Z",
    fill: "url(#paint1_linear_1792_12297)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.333 209.089V120.861H284.939C290.886 120.861 296.001 122.054 300.281 124.44C304.562 126.825 307.846 129.978 310.133 133.899C312.421 137.821 313.564 142.101 313.564 146.741C313.564 151.447 312.388 155.695 310.035 159.485C307.682 163.276 304.382 166.25 300.134 168.406L326.602 209.089H310.427L286.606 172.033H274.45V209.089H260.333ZM274.45 159.976H284.743C288.207 159.976 291.05 159.322 293.272 158.015C295.494 156.708 297.128 155.041 298.173 153.015C299.219 150.989 299.742 148.898 299.742 146.741C299.742 142.951 298.37 139.847 295.625 137.428C292.88 135.01 289.252 133.802 284.743 133.802H274.45V159.976Z",
    fill: "url(#paint2_linear_1792_12297)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M324.152 133.802V120.861H383.95V133.802H361.403V209.089H346.698V133.802H324.152Z",
    fill: "url(#paint3_linear_1792_12297)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M414.829 120.861H400.125V209.089H414.829V120.861Z",
    fill: "url(#paint4_linear_1792_12297)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M437.475 209.089V120.861H482.765V133.508H451.591V149.682H475.902V162.034H451.591V196.148H482.765V209.089H437.475Z",
    fill: "url(#paint5_linear_1792_12297)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M520.114 210.657C514.821 210.657 509.919 209.628 505.409 207.569C500.9 205.51 497.305 203.043 494.626 200.168L498.645 183.6C500.671 187.391 503.644 190.692 507.566 193.501C511.487 196.312 515.833 197.717 520.604 197.717C524.721 197.717 528.054 196.492 530.603 194.041C533.152 191.59 534.426 188.568 534.426 184.973C534.426 182.294 533.773 180.071 532.465 178.307C531.159 176.543 529.672 175.121 528.005 174.043C526.339 172.964 524.95 172.164 523.839 171.641L513.252 166.249C510.899 165.073 508.399 163.553 505.752 161.691C503.106 159.828 500.883 157.41 499.086 154.437C497.289 151.463 496.391 147.722 496.391 143.212C496.391 138.507 497.469 134.357 499.626 130.762C501.782 127.168 504.805 124.358 508.693 122.332C512.582 120.306 517.108 119.293 522.27 119.293C527.237 119.293 531.648 120.126 535.504 121.793C539.36 123.459 542.432 125.207 544.719 127.037L540.798 143.31C538.707 140.239 535.946 137.592 532.514 135.37C529.083 133.148 525.473 132.036 521.683 132.036C518.088 132.036 515.278 133.017 513.252 134.978C511.226 136.938 510.213 139.389 510.213 142.33C510.213 144.356 510.686 146.088 511.634 147.526C512.582 148.963 513.758 150.156 515.163 151.103C516.568 152.051 517.957 152.884 519.33 153.603L530.113 158.995C531.616 159.714 533.397 160.71 535.455 161.985C537.514 163.259 539.524 164.877 541.485 166.838C543.445 168.798 545.063 171.183 546.337 173.994C547.611 176.804 548.249 180.169 548.249 184.091C548.249 189.188 547.056 193.73 544.67 197.717C542.285 201.704 539.001 204.856 534.819 207.177C530.636 209.497 525.734 210.657 520.114 210.657Z",
    fill: "url(#paint6_linear_1792_12297)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M233.987 101.497V57.4863H247.044C249.912 57.4863 252.195 58.0407 253.89 59.149C255.585 60.2575 256.799 61.6021 257.533 63.1833C258.266 64.7645 258.633 66.2722 258.633 67.7065C258.633 69.141 258.332 70.4694 257.728 71.692C257.125 72.9143 256.286 73.9494 255.21 74.7971C257.427 75.9706 259.212 77.6168 260.565 79.736C261.918 81.8549 262.594 84.251 262.594 86.9242C262.594 89.3368 261.999 91.6594 260.809 93.8926C259.619 96.1255 257.842 97.9511 255.479 99.3694C253.115 100.787 250.206 101.497 246.75 101.497H233.987ZM241.029 95.0417H246.115C248.299 95.0417 250.059 94.6096 251.396 93.7459C252.732 92.882 253.702 91.8061 254.305 90.5185C254.909 89.2307 255.21 87.9511 255.21 86.6797C255.21 85.4409 254.917 84.1695 254.33 82.8655C253.743 81.5615 252.789 80.4776 251.469 79.6137C250.149 78.7498 248.364 78.3179 246.115 78.3179H241.029V95.0417ZM241.029 72.8899H246.115C247.81 72.8899 249.195 72.4743 250.271 71.6429C251.347 70.8116 251.885 69.6299 251.885 68.0977C251.885 66.4677 251.363 65.2452 250.32 64.4303C249.277 63.6151 247.94 63.2077 246.31 63.2077H241.029V72.8899Z",
    fill: "url(#paint7_linear_1792_12297)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.662 101.497V57.4863H293.254V63.7945H277.704V71.8631H289.831V78.0245H277.704V95.0417H293.254V101.497H270.662Z",
    fill: "url(#paint8_linear_1792_12297)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M311.885 102.278C309.245 102.278 306.8 101.765 304.55 100.737C302.301 99.7106 300.508 98.4801 299.171 97.0456L301.176 88.7814C302.187 90.6722 303.67 92.3187 305.626 93.7203C307.582 95.1222 309.75 95.823 312.13 95.823C314.184 95.823 315.846 95.2118 317.118 93.9893C318.389 92.7669 319.025 91.2592 319.025 89.4661C319.025 88.1294 318.699 87.0212 318.047 86.1408C317.395 85.2607 316.653 84.5516 315.822 84.0137C314.99 83.4757 314.298 83.0765 313.744 82.8158L308.462 80.1263C307.289 79.5393 306.042 78.7814 304.721 77.8522C303.401 76.9233 302.293 75.7172 301.396 74.2338C300.5 72.7505 300.052 70.8841 300.052 68.6347C300.052 66.2875 300.589 64.2174 301.665 62.4245C302.741 60.6313 304.249 59.2297 306.188 58.2191C308.128 57.2084 310.386 56.7031 312.961 56.7031C315.439 56.7031 317.639 57.1188 319.563 57.9501C321.486 58.7814 323.018 59.6533 324.159 60.5661L322.203 68.6836C321.16 67.1514 319.783 65.8312 318.071 64.7227C316.36 63.6142 314.559 63.0601 312.668 63.0601C310.875 63.0601 309.473 63.5492 308.462 64.5272C307.452 65.5052 306.946 66.7275 306.946 68.1947C306.946 69.2053 307.183 70.069 307.655 70.7863C308.128 71.5035 308.715 72.0985 309.416 72.5712C310.117 73.0439 310.809 73.4595 311.494 73.8182L316.873 76.5076C317.623 76.8663 318.511 77.3634 319.538 77.9989C320.565 78.6347 321.567 79.4417 322.545 80.4197C323.523 81.3977 324.33 82.5874 324.966 83.9893C325.602 85.3912 325.92 87.07 325.92 89.026C325.92 91.5688 325.325 93.8346 324.135 95.823C322.945 97.8116 321.307 99.3846 319.22 100.542C317.134 101.699 314.689 102.278 311.885 102.278Z",
    fill: "url(#paint9_linear_1792_12297)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M329.049 63.9411V57.4863H358.878V63.9411H347.631V101.497H340.296V63.9411H329.049Z",
    fill: "url(#paint10_linear_1792_12297)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M346.082 268.483V224.473H368.674V230.781H353.124V238.849H365.251V245.011H353.124V262.028H368.674V268.483H346.082Z",
    fill: "url(#paint11_linear_1792_12297)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M389.994 269.95L371.901 224.473H379.481L388.283 246.771C388.641 247.684 388.984 248.572 389.31 249.436C389.636 250.3 389.962 251.286 390.288 252.394C390.581 251.319 390.891 250.357 391.217 249.509C391.543 248.662 391.885 247.749 392.244 246.771L400.997 224.473H408.185L390.092 269.95H389.994Z",
    fill: "url(#paint12_linear_1792_12297)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M414.053 268.483V224.473H436.645V230.781H421.095V238.849H433.222V245.011H421.095V262.028H436.645V268.483H414.053Z",
    fill: "url(#paint13_linear_1792_12297)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M445.007 268.483V224.473H457.281C460.247 224.473 462.798 225.067 464.934 226.257C467.069 227.447 468.707 229.02 469.848 230.976C470.989 232.932 471.56 235.068 471.56 237.382C471.56 239.729 470.973 241.848 469.799 243.739C468.626 245.63 466.979 247.113 464.86 248.189L478.063 268.483H469.995L458.112 249.998H452.049V268.483H445.007ZM452.049 243.984H457.183C458.911 243.984 460.329 243.658 461.437 243.006C462.546 242.354 463.361 241.522 463.882 240.512C464.404 239.501 464.665 238.458 464.665 237.382C464.665 235.491 463.98 233.943 462.611 232.737C461.242 231.53 459.433 230.927 457.183 230.927H452.049V243.984Z",
    fill: "url(#paint14_linear_1792_12297)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.489 224.472L228.559 332L0 143.567L203.639 0L211.316 102.277H202.166L195.745 16.7285L15.0303 144.133L217.86 311.355L211.339 224.472H220.489Z",
    fill: "url(#paint15_linear_1792_12297)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1792_12297",
    x1: 131.048,
    y1: 102.277,
    x2: 548.248,
    y2: 295.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FFC8AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7131"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1792_12297",
    x1: 131.048,
    y1: 102.277,
    x2: 548.248,
    y2: 295.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FFC8AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7131"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1792_12297",
    x1: 131.048,
    y1: 102.277,
    x2: 548.248,
    y2: 295.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FFC8AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7131"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1792_12297",
    x1: 131.049,
    y1: 102.277,
    x2: 548.248,
    y2: 295.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FFC8AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7131"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1792_12297",
    x1: 131.049,
    y1: 102.277,
    x2: 548.248,
    y2: 295.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FFC8AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7131"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1792_12297",
    x1: 131.049,
    y1: 102.277,
    x2: 548.248,
    y2: 295.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FFC8AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7131"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1792_12297",
    x1: 131.049,
    y1: 102.277,
    x2: 548.248,
    y2: 295.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FFC8AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7131"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1792_12297",
    x1: 131.048,
    y1: 102.279,
    x2: 548.246,
    y2: 295.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FFC8AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7131"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1792_12297",
    x1: 131.048,
    y1: 102.279,
    x2: 548.246,
    y2: 295.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FFC8AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7131"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1792_12297",
    x1: 131.048,
    y1: 102.278,
    x2: 548.246,
    y2: 295.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FFC8AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7131"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1792_12297",
    x1: 131.048,
    y1: 102.279,
    x2: 548.246,
    y2: 295.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FFC8AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7131"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1792_12297",
    x1: 131.048,
    y1: 102.277,
    x2: 548.248,
    y2: 295.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FFC8AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7131"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1792_12297",
    x1: 131.048,
    y1: 102.277,
    x2: 548.248,
    y2: 295.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FFC8AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7131"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1792_12297",
    x1: 131.048,
    y1: 102.277,
    x2: 548.248,
    y2: 295.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FFC8AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7131"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1792_12297",
    x1: 131.048,
    y1: 102.277,
    x2: 548.248,
    y2: 295.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FFC8AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7131"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1792_12297",
    x1: 10.504,
    y1: 123.996,
    x2: 219.65,
    y2: 176.444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#872B95"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.0ebf49cdf5211e7c6364aba48e47e3a6.svg";
export { ForwardRef as ReactComponent };